// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  TicketStatus,
  TicketType,
} from '../../../../_interfaces/service-ticket-model';
import { TicketModelFIXED } from '../../services/service-tickets.service';

export function isPlannedActivity(ticket: TicketModelFIXED): boolean {
  return (
    ticket.ticketType !== TicketType.ServiceTicket &&
    ticket.status !== TicketStatus.Closed
  );
}

export function isServiceTicket(ticket: TicketModelFIXED): boolean {
  return !isPlannedActivity(ticket);
}

export function isValidTicket(ticket: TicketModelFIXED): boolean {
  // ticket is invalid only if it is a ServiceTicket with both plannedStart and plannedEnd as null
  if (
    ticket.ticketType === TicketType.ServiceTicket &&
    ticket.plannedStart === null &&
    ticket.plannedEnd === null
  ) {
    return false;
  }
  return true;
}
